import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=012b762a&scoped=true"
import script from "./FilePreview.vue?vue&type=script&lang=ts"
export * from "./FilePreview.vue?vue&type=script&lang=ts"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=012b762a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012b762a",
  null
  
)

export default component.exports